import React, {useEffect} from 'react';

import {Button, Form, FormGroup, Row} from "react-bootstrap";
import {PrinterStateData} from "../commons/Const";
import {DataAPI, MutationAPI, NotificationSettings, useData, useMutator} from "../services/API";
import {Formik} from "formik";
import {FormButtonGroup, FormikControl, Loading} from "./Components";
import {PrinterState} from "./PrinterStates";


const PrinterNotifications = ({printerId}) => {

    useEffect(()=>{
        console.log('mount for: ', printerId);
        return ()=>console.log('unmount for: ', printerId);
    }, []);

    const changeNotifications = useMutator(MutationAPI.saveNotifications, {
        customMsg: 'Zapisano ustawienia notyfikacji.'
    });

    const { isLoading, error, data, invalidate } = useData(printerId, 'printer-notifications', DataAPI.getNotifications, { refetchOnMount: true});

    //ustawienia globalne (bez drukarki) mają dodatkowo tryb treści maila
    const global = printerId == null;

    const submit = (values, {setSubmitting}) => {
        setSubmitting(true);
        const req: NotificationSettings = {printerId, notificationKeys: values.alerts};
        if (global) req.notifyMode = values.notifyMode;
        changeNotifications.mutate(req, {
            onSettled: ()=>setSubmitting(false),
            onSuccess: invalidate
        });
    }

    if (isLoading) return <Loading />;
    if (error) return <p>{error.message}</p>;

    const keys: string[] = data.notificationKeys;

    return <div className="settings-section notifications-settings">
        <h2>Ustawienia notyfikacji</h2>
        <Formik enableReinitialize={true} initialValues={{alerts: keys, notifyMode: data.notifyMode || 'new'}} onSubmit={submit} >
            {({ handleSubmit, values, isSubmitting, handleReset }) => (
                <Form noValidate onSubmit={handleSubmit} className="form form-change-notify settings-form">
                    <FormGroup className="notifications notifications-grid">
                        <FormikControl key={keys} type="checkboxGroup" name="alerts" builder={(key)=><PrinterState entry={PrinterStateData[key]} />} domain={AlertsDomain}/>
                    </FormGroup>
                    {global && <FormGroup className="notifications-mode">
                        <Form.Label className="notifications-mode-label">Treść maila</Form.Label>
                        <FormikControl type="radioGroup" name="notifyMode" domain={NotifyModeDomain}/>
                    </FormGroup>}
                    <FormButtonGroup>
                        <Button variant="primary" disabled={isSubmitting} type="submit">Zapisz</Button>
                    </FormButtonGroup>
                </Form>
            )}
        </Formik>
    </div>;
}
const AlertsDomain = Object.keys(PrinterStateData).filter(k=>k!=='ok'&&k!=='notOk'&&k!=='manualCounterEntry');
//wartości zgodne z NotificationSettings.notifyMode po stronie serwera
const NotifyModeDomain = [
    {value: 'new', label: 'Powiadamiaj tylko o nowych zdarzeniach'},
    {value: 'all', label: 'Zawsze wysyłaj wszystkie aktualne alerty drukarki (nowe i trwające)'},
];
export default PrinterNotifications;